import axios from "axios";
import React, { useEffect, useState } from "react";
import { api_url } from "../Hooks/Global";

function Training() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [keyword, setKeyword] = useState("");
    const [applyFilter, setApplyFilter] = useState(false);

    const [next, setNext] = useState(false);
    const [prev, setPrev] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const primary = "#002147";
    const secondary = "#fdc800";

    const getFranchises = async () => {
        try {
            setLoading(true);

            const response = await axios.get(`${api_url}Franchise/GetFranchisesList`, {
                params: { keyword, page, limit },
            });

            const {
                success,
                data: rows = [],
                total_records = 0,
                total_pages = 0,
                next = false,
                prev = false,
                page: currentPage = 1,
            } = response.data;

            if (success) {
                setData(rows);
                setTotalRecords(total_records);
                setTotalPages(total_pages);
                setNext(next);
                setPrev(prev);
                setPage(currentPage);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error(error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getFranchises();
    }, [page, limit, applyFilter]);

    const handleSearch = () => {
        setPage(1);
        setApplyFilter(prev => !prev);
    };
    
    const handleClear = () => {
        setKeyword("");
        setPage(1);
        setApplyFilter(prev => !prev);
    };

    const getStatusBadge = (status) => {
        if (status === 1)
            return (
                <span className="badge rounded-pill" style={{ background: primary }}>
                    Active
                </span>
            );

        if (status === 2)
            return (
                <span className="badge rounded-pill bg-danger">
                    Inactive
                </span>
            );

        return (
            <span className="badge rounded-pill bg-secondary">
                Unknown
            </span>
        );
    };

    const renderPagination = () => {
        if (!totalPages) return null;

        let start = Math.max(1, page - 2);
        let end = Math.min(totalPages, page + 2);

        if (page <= 2) {
            end = Math.min(totalPages, 5);
        }
        if (page >= totalPages - 1) {
            start = Math.max(1, totalPages - 4);
        }

        const pages = [];
        for (let i = start; i <= end; i++) pages.push(i);

        return (
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2 mt-3">
                <div className="text-muted small">
                    Showing <b>{data?.length || 0}</b> of <b>{totalRecords}</b> records
                </div>

                <nav>
                    <ul className="pagination mb-0">
                        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                            <button
                                className="page-link"
                                onClick={() => setPage((p) => Math.max(1, p - 1))}
                            >
                                Prev
                            </button>
                        </li>

                        {start > 1 && (
                            <>
                                <li className="page-item">
                                    <button className="page-link" onClick={() => setPage(1)}>
                                        1
                                    </button>
                                </li>
                                {start > 2 && (
                                    <li className="page-item disabled">
                                        <span className="page-link">...</span>
                                    </li>
                                )}
                            </>
                        )}

                        {pages.map((p) => (
                            <li key={p} className={`page-item ${p === page ? "active" : ""}`}>
                                <button
                                    className="page-link"
                                    onClick={() => setPage(p)}
                                    style={
                                        p === page
                                            ? { background: primary, borderColor: primary }
                                            : {}
                                    }
                                >
                                    {p}
                                </button>
                            </li>
                        ))}

                        {end < totalPages && (
                            <>
                                {end < totalPages - 1 && (
                                    <li className="page-item disabled">
                                        <span className="page-link">...</span>
                                    </li>
                                )}
                                <li className="page-item">
                                    <button
                                        className="page-link"
                                        onClick={() => setPage(totalPages)}
                                    >
                                        {totalPages}
                                    </button>
                                </li>
                            </>
                        )}

                        <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                            <button
                                className="page-link"
                                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                            >
                                Next
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        );
    };

    return (
        <>
            <div
                className="inner-page-banner-area"
                style={{
                    backgroundImage: 'url("/images/About_images/about_banner.jpg")',
                }}
            >
                <div className="container">
                    <div className="pagination-area">
                        <h1>Franchises List</h1>
                    </div>
                </div>
            </div>

            <div className="training-center-area py-4">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div
                                className="card border-0 shadow-sm"
                                style={{ borderRadius: "14px" }}
                            >
                                <div
                                    className="card-header d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2"
                                    style={{
                                        background: primary,
                                        color: "white",
                                        borderTopLeftRadius: "14px",
                                        borderTopRightRadius: "14px",
                                    }}
                                >
                                    <div>
                                        <h5 className="mb-0 fw-bold text-white">Franchise Directory</h5>
                                        <small style={{ color: secondary }}>
                                            Search, view and manage franchises
                                        </small>
                                    </div>

                                    <div className="d-flex gap-2 align-items-center">
                                        <div className="input-group">
                                            <span
                                                className="input-group-text"
                                                style={{ background: "white" }}
                                            >
                                                <i className="fa fa-search"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search by Franchise Name"
                                                value={keyword}
                                                onChange={(e) => setKeyword(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") handleSearch();
                                                }}
                                            />
                                        </div>

                                        <button
                                            className="btn"
                                            style={{
                                                background: secondary,
                                                color: primary,
                                                fontWeight: 700,
                                                whiteSpace: "nowrap",
                                            }}
                                            onClick={handleSearch}
                                            disabled={loading}
                                        >
                                            Search
                                        </button>

                                        <button
                                            className="btn btn-light"
                                            onClick={handleClear}
                                            disabled={loading}
                                        >
                                            Clear
                                        </button>
                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                                        <div className="text-muted small">
                                            Total Records: <b>{totalRecords}</b>
                                        </div>

                                        <div className="d-flex align-items-center gap-2">
                                            <span className="text-muted small">Rows:</span>
                                            <select
                                                className="form-select form-select-sm"
                                                style={{ width: "90px" }}
                                                value={limit}
                                                onChange={(e) => {
                                                    setLimit(Number(e.target.value));
                                                    setPage(1);
                                                }}
                                            >
                                                <option value={5}>5</option>
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover align-middle mb-0">
                                            <thead style={{ background: "#f8f9fa" }}>
                                                <tr>
                                                    <th style={{ width: "70px" }}>#</th>
                                                    <th>Franchise</th>
                                                    <th>District</th>
                                                    <th>City</th>
                                                    <th>State</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan={8} className="text-center py-4">
                                                            <div className="spinner-border" role="status"></div>
                                                            <div className="mt-2 text-muted">
                                                                Loading franchises...
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : data?.length > 0 ? (
                                                    data.map((item, index) => (
                                                        <tr key={item?.franchise_id || index}>
                                                            <td className="fw-bold">
                                                                {(page - 1) * limit + index + 1}
                                                            </td>

                                                            <td>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <div
                                                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                                                        style={{
                                                                            width: 42,
                                                                            height: 42,
                                                                            background: secondary,
                                                                            color: primary,
                                                                            fontWeight: 800,
                                                                        }}
                                                                    >
                                                                        {(item?.franchise_name || "F")
                                                                            .toString()
                                                                            .charAt(0)
                                                                            .toUpperCase()}
                                                                    </div>

                                                                    <div>
                                                                        <div className="fw-semibold">
                                                                            {item?.franchise_name || "-"}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className="fw-semibold">
                                                                    {item?.franchise_district || "-"}
                                                                </div>
                                                                
                                                            </td>

                                                            <td>
                                                                <div className="fw-semibold">
                                                                    {item?.franchise_city || "-"}
                                                                </div>
                                                            </td>
                                                            <td className="fw-semibold">
                                                                {item?.franchise_state || "-"}
                                                            </td>

                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={8} className="text-center py-4">
                                                            <div className="fw-semibold">No Records Found</div>
                                                            <div className="text-muted small">
                                                                Try searching with a different keyword.
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {renderPagination()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Training;
